import React, { useEffect, useState } from "react";
import { getCursoData } from "../../services/misCursosService";
import useTokenValidation from "../../../../../../hooks/useTokenValidation";
import { useNavigate } from "react-router-dom";
import { V_URL_API } from "../../../../../../utils/config";
import { Oval } from "react-loader-spinner";

export default function SeccionCursoSeleccionado({}) {
  const { tokenEntity, resetearToken, errores, notificacionRef } =
    useTokenValidation();
  const [vCursoSeleccionadoInfo, setVCursoSeleccionadoInfo] = useState(null);
  const [vIsCargandoInfo, setVIsCargandoInfo] = useState(false);

  const navigate = useNavigate();

  const mGetCursoFetch = () => {
    getCursoData(tokenEntity.token)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        // Manejo de diferentes tipos de errores basados en el código de estado
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");

          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");

          case 500:
            console.log("Error al obtener el curso");
            throw new Error("ERR_SERVER");

          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined) {
          setVCursoSeleccionadoInfo(result["detail"]["datos"]);
        }
      })
      .catch((error) => {
        // Separar las propiedades del error
        const { message } = error;
        if (message !== "ERR_ME") {
          //console.log("Error de red");
        }
      })
      .finally(() => {
        setVIsCargandoInfo(false);
      });
  };

  useEffect(() => {
    setVIsCargandoInfo(true);
    if (!tokenEntity.isValidando) {
      setVCursoSeleccionadoInfo(null);
      mGetCursoFetch();
    }
  }, [tokenEntity.isValidando]);

  if (vIsCargandoInfo || !vCursoSeleccionadoInfo) {
    return <Oval
            visible={true}
            height="50"
            width="50"
            color="#fff"
            secondaryColor="#f5f5f5"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
  }

  return (
    <div class="mis-cursos-info-1">
      <>
        <div class="info-1-curso">
          <div class="info-1-curso-titulo">
            <div class="info-1-curso-titulo-1">
              {vCursoSeleccionadoInfo.curso.nombre_curso}
            </div>
            <div class="info-1-curso-titulo-2">
              {
                vCursoSeleccionadoInfo.leccion_actual_curso
                  .nombre_leccion_curso_actual
              }
            </div>
          </div>
          <div class="info-1-curso-video">
            <div class="video">
              <div data-figma-id="1621:15241" class="icono-play" onClick={() =>
                navigate(
                  `?f=cc&curso_id=${vCursoSeleccionadoInfo.curso.curso_id}&leccion_id=${vCursoSeleccionadoInfo.leccion_actual_curso.id}`
                )
              }>
                <i
                  className={`fi fi-sr-play tocar-1`}
                ></i>
              </div>
              <div
                class="video-frame"
                style={{
                  backgroundImage: `url('${V_URL_API}/api/img_video_leccion/${
                    vCursoSeleccionadoInfo.leccion_actual_curso.id
                  }/thumbnail/s?_t=${Date.now()}')`,
                }}
              ></div>
              <div class="barra-reproduccion">
                <div class="barra-reproduccion-tiempo">
                  {Math.floor(
                    vCursoSeleccionadoInfo.leccion_actual_curso.video
                      .progreso_video / 60
                  )}
                  :
                  {Math.floor(
                    vCursoSeleccionadoInfo.leccion_actual_curso.video
                      .progreso_video % 60
                  )
                    .toString()
                    .padStart(2, "0")}{" "}
                  /{" "}
                  {Math.floor(
                    vCursoSeleccionadoInfo.leccion_actual_curso.video
                      .duracion_total / 60
                  )}
                  :
                  {Math.floor(
                    vCursoSeleccionadoInfo.leccion_actual_curso.video
                      .duracion_total % 60
                  )
                    .toString()
                    .padStart(2, "0")}
                </div>
                <div
                  class="barra-reproduccion-duracion"
                  style={{ cursor: "default" }}
                >
                  <div class="barra-reproduccion-2"></div>
                  <div
                    class="barra-reproduccion-1-2"
                    style={{
                      width: `${vCursoSeleccionadoInfo.leccion_actual_curso.video.porcentaje_completado}`,
                    }}
                  ></div>
                  <div
                    class="barra-reproduccion-circulo"
                    style={{
                      cursor: "default",
                      inset: `0% 0% 0% ${vCursoSeleccionadoInfo.leccion_actual_curso.video.porcentaje_completado}`,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="video-info">
            <div class="profesor-texto">por Luis Ramírez</div>
            <div class="proveedor-texto">MHM</div>
            <div class="idioma">
              <i class="fi fi-rs-globe globo-2"></i>

              <div class="idoma-texto">Español</div>
            </div>
          </div>
        </div>
        <div class="linea-miscursos-v"></div>
        <div class="info-2-mis-cursos">
          <div class="proximas-lecciones">
            <div class="lecciones-texto-1">Próximas lecciones</div>
            {vCursoSeleccionadoInfo.siguientes_lecciones.map((seccion) => (
              <>
                <div class="lecciones-texto-2">
                  Sección {seccion.numero_seccion}: {seccion.nombre_seccion}
                </div>
                {seccion.lecciones.map((leccion) => (
                  <div class="leccion" key={leccion.numero_leccion}>
                    <div class="leccion-info">
                      <i class="fi fi-rs-lock icon-2"></i>
                      <div class="leccion-info-texto">
                        Lección {leccion.numero_leccion}: {leccion.nombre}
                      </div>
                    </div>
                    <div class="leccion-minutos">{leccion.duracion}</div>
                  </div>
                ))}
              </>
            ))}
          </div>
          <div class="linea-miscursos-h"></div>
          <div class="tarjeta-2-mis-cursos">
            <div class="contenido">
              <div class="contenido-1">
                {
                  vCursoSeleccionadoInfo.leccion_actual_curso
                    .nombre_leccion_curso_actual
                }
              </div>
              <div class="contenido-2">
                {vCursoSeleccionadoInfo.curso.nombre_curso}
              </div>
              <div class="contenido-3 truncate-5-line">
                {vCursoSeleccionadoInfo.curso.objetivo_general_curso}
              </div>
              <div class="contenido-4">
                Duración: {vCursoSeleccionadoInfo.leccion_actual_curso.duracion}
              </div>
            </div>
            <div
              class="boton-continuar"
              onClick={() =>
                navigate(
                  `?f=cc&curso_id=${vCursoSeleccionadoInfo.curso.curso_id}&leccion_id=${vCursoSeleccionadoInfo.leccion_actual_curso.id}`
                )
              }
            >
              <div class="boton-continuar-texto">Continuar</div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}
